module["exports"] = [
  "#{street_name}#{building_number}号"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_CN/address/street_address.js
 ** module id = 1184
 ** module chunks = 0
 **/